import { RoleNames } from "@/data/selectors/roles";

export const NEWS_EDITOR_ROLES = [
  RoleNames.SuperAdmin,
  RoleNames.OrdinaryAdmin,
  RoleNames.NewsEditor,
];

export function hasNewsEditorAccess(auth) {
  const roles = auth?.roles ?? [];
  return NEWS_EDITOR_ROLES.some((role) => roles.includes(role));
}

export const NEWS_ADMIN_RELOAD_EVENT = "reload-news-admin";
